import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { failedResponse, getBackendUrl, loaded, loading, error, LoadStateInfo, LoadState, notStarted } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { RootState } from "../../app/store";
import { ConversationUserStatus } from "./conversationSlice";

export interface ChangeConversationUserStatusRequest {
    conversationId: string;
    status: ConversationUserStatus;
}

export const changeConversationUserStatus = createAsyncThunk(
    "changeConversationUserStatus",
    async (param: ChangeConversationUserStatusRequest, thunkAPI) => {
        console.debug("change conversation user status");

        const response = await fetch(`${getBackendUrl()}/api/conversation/${param.conversationId}/status/${param.status}`, {
            method: "PATCH",
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${getToken()}`,
            }
        });

        if (response.ok) {
            return "OK";
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    },
    {
        condition: (param: ChangeConversationUserStatusRequest, thunkAPI) => {
            const state = thunkAPI.getState() as RootState;
            const status = state.conversationUser.change.status;
            if (status.state != LoadState.Loading) {
                return true;
            }
            return false;
        }
    }
);

export interface ChangeStatusRequest {
    status: LoadStateInfo,
    request?: ChangeConversationUserStatusRequest;
}

export interface ConversationUserState {
    change: ChangeStatusRequest;
}

const initialState: ConversationUserState = {
    change: {
        status: notStarted(),
    }
};

export const conversationUserSlice = createSlice({
    name: "conversationUser",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(changeConversationUserStatus.pending, (state, action) => {
                state.change.status = loading();
                state.change.request = action.meta.arg;
            })
            .addCase(changeConversationUserStatus.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                state.change.status = loaded();
            })
            .addCase(changeConversationUserStatus.rejected, (state, action) => {
                state.change.status = error(action);
            });
    },
});

// export const { } = conversationUserSlice.actions;

export const selectConversationUser = (state: RootState) => state.conversationUser;

export default conversationUserSlice.reducer;
